<template>
	<div>
		<div v-loading="uploading">
			<el-upload
				class="upload-demo"
				ref="upload"
				:accept="accept"
				:action="uploadUrl"
				:http-request="fileUpload"
				:on-remove="handleRemove"
				:on-change="onChange"
				:on-success="onSuccess"
				:on-error="onError"
				:file-list="fileList"
				:headers="headers"
				:before-upload="beforeUpload"
				drag
				:multiple="false"
				:auto-upload="false"
			>
				<div class="el-upload__text"><em>点击选择文件</em></div>
			</el-upload>
			<div style="margin-left: 15%; margin-top: 10px">
				<el-button style="margin: 0px 20px;" :disabled="fileList.length == 0" size="small" type="success" @click="submitUpload"
					>上传</el-button
				>
				<el-button style="margin: 0px 20px;" size="small" type="success" @click="downloadTemplate">下载模版</el-button>
			</div>
			<div slot="tip" class="el-upload__tip">{{ tip }}</div>
		</div>
	</div>
</template>

<script>
import { download, upload, alertMessageBox } from "@/assets/common/request";
import mixin from "@/mixin/index";
export default {
	name: "UploadExcel",
	mixins: [mixin],
	props: {
		uploadUrl: {
			type: String,
			default: function() {
				return "";
			},
		},
		templateUrl: {
			type: String,
			default: function() {
				return "";
			},
		},
		limitM: {
			type: Number,
			default: function() {
				return 5;
			},
		},
		tip: {
			type: String,
			default: "导入文件不能超过5M，仅允许导入xlsx”格式文件！",
		},
	},
	data() {
		return {
            uploading: false,
			accept: "xlsx",
			headers: {},
			fileList: [],
		};
	},
	methods: {
		submitUpload() {
			this.$refs.upload.submit();
		},
		handleRemove(file, fileList) {
			this.fileList = fileList;
		},
		fileUpload(file) {
            this.uploading = true;
			this.doFileUpload(file)
            .then((data) => {
				alertMessageBox(data);
			}).finally(() => {
                this.uploading = false;
            });
		},
		doFileUpload(fileobj) {
			return upload(this.uploadUrl, fileobj.file);
		},
		onChange(file) {
			this.fileList = [];
			this.fileList.push(file);
		},
		downloadTemplate() {
            this.uploading = true;
			download(this.templateUrl).finally(() => {
                this.uploading = false;
            });
		},
		beforeUpload(file) {
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			const extension = testmsg === "xls";
			const extension2 = testmsg === "xlsx";
			const fileSize = file.size;
			const limitSize = this.limitM * 1024 * 1024;
			if (!extension && !extension2) {
				this.$message({
					message: this.tip,
					type: "warning",
				});
				return false;
			}
			if (fileSize > limitSize) {
				this.$message({
					message: "上传文件大小超过限制!",
					type: "warning",
				});
				return false;
			}
			return extension2;
			// return extension || extension2;
		},
		onSuccess(response, file, fileList) {
			this.uploading = false;
		},
		onError(error, file, fileList) {
			this.uploading = false;
		},
	},
};
</script>

<style scoped>
.el-upload__text {
	bottom: 30px;
	position: absolute;
	left: 40%;
}
</style>
